import React from 'react';
import Layout from './Layout';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false }
    }
    static getDerivedStateFromError(error) {
        return { hasError: true }
    }
    componentDidCatch(error, errorInfo) {
        console.log({ error, errorInfo })
    }

    close = () => {
        window.history.forward(1);
        window.location.reload(true);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Layout
                    Head={{
                        title: 'OOPS! Something went wrong',
                    }}
                >
                    <main className="bg-greys pt-80 pb-50">
                        <div className="container">
                            <div className="row pt-80">
                                <div className="col-lg-2 col-md-12 d-lg-block d-none" />
                                <div className="col-lg-3 col-md-12 d-lg-block d-none pr-50">
                                    <img src="assets/img/icon2.png" alt="FayaVotes" />
                                </div>
                                <div className="col-lg-5 col-md-12 pl-50 text-md-center text-lg-left">
                                    <h1 className="mb-20 font-weight-900 page-404">OOPS!</h1>
                                    <p className="">
                                        Something went wrong! Rest assured, our Engineers have been notified.
                                    </p>
                                    <div className="form-group">
                                        <button type="submit" className="button button-contactForm mt-20" onClick={this.close}>
                                            Okay
                                        </button>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-12 d-lg-block d-none" />
                            </div>
                        </div>
                    </main>
                </Layout>
            )
        }
        return this.props.children;
    }
}

export default ErrorBoundary